import React from 'react';
import * as R from 'ramda';

import {FormLabel} from 'js/form_components';
import MultiSelectInput from './multi_select_input';

export default function MultiSelectInputGroup(props) {
    const options = R.map(option => ({value: option.value, label: option.label}), props.options);
    const label = props.header || '';
    const name = props.name || '';

    const keyValueInputs = props.keyValueTags.map((keyValue, index) => (
        <MultiSelectInput
            keyValue={keyValue}
            index={index}
            key={index}
            name={name}
            options={options}
            multiSelect={props.multiSelect}
            onChangeKey={R.partial(props.onChangeKey, [index])}
            onChangeValue={R.partial(props.onChangeValue, [index])}
            onRemoveKeyValue={R.partial(props.onRemoveKeyValue, [index])}
        />
    ));

    return (
        <div className="form-group">
            <FormLabel
                className={props.className}
                label={label}
                helpText={props.help}
                multiline
                inline
                place="right"
            />
            {keyValueInputs}
            <div className="pull-right addItem" onClick={props.onAddKeyValue}>
                &#9998;
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./publisher_leads/advanced_filters/multi_select_group/index.js